<mat-dialog-content>
  {{data["message"]}}
</mat-dialog-content>
